import React from 'react';
import { ChevronDown } from 'lucide-react';
import { cn } from '../../lib/utils';

interface CustomSelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  containerClassName?: string;
  hideChevron?: boolean;
}

export const CustomSelect = React.forwardRef<HTMLSelectElement, CustomSelectProps>(
  ({ label, error, className, containerClassName, hideChevron, children, ...props }, ref) => {
    return (
      <div className={cn("space-y-1.5", containerClassName)}>
        {label && (
          <h4 className="text-[10px] uppercase tracking-widest font-bold opacity-40">
            {label}
          </h4>
        )}
        <div className="relative group">
          <select
            ref={ref}
            className={cn(
              "w-full appearance-none bg-background border border-input px-3 py-2 rounded-md text-sm font-medium text-foreground outline-none",
              "transition-all duration-200",
              "focus:border-ring focus:ring-2 focus:ring-ring/20",
              "hover:border-primary/40",
              "disabled:opacity-50 disabled:cursor-not-allowed",
              error && "border-red-500 focus:border-red-500 focus:ring-red-500/5",
              className
            )}
            {...props}
            value={props.value ?? ''}
          >
            {children}
          </select>
          {!hideChevron && (
            <div className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground transition-colors group-focus-within:text-foreground">
              <ChevronDown className="w-4 h-4" />
            </div>
          )}
        </div>
        {error && <p className="text-[10px] text-red-500 font-bold uppercase tracking-wider">{error}</p>}
      </div>
    );
  }
);

CustomSelect.displayName = 'CustomSelect';
